export default {
  paused: false,
  scene: null,
  view: null,
  data: null,
  player: null,
  character: null,
  history: []
}
